export const loginKeys = {
  all: () => ['authentication'],
  otp: {
    all: () => [...loginKeys.all(), 'otp'],
    detail: (instanceId: number, employeeInternalId: string) =>
      [...loginKeys.otp.all(), instanceId, employeeInternalId],
    send: () => [...loginKeys.otp.all(), 'send'],
    login: () => [...loginKeys.otp.all(), 'login'],
  },
};
